export default __webpack_public_path__ + "static/media/icon-close-x.dbc127bc.svg";